import moment from "moment";
import { Model, TIME_FORMAT } from "@/models/Model";
import { HOURS, MINUTES } from "@/utils";
export class Settings extends Model {
    constructor() {
        super();
        this.data.firstTee = "";
        this.data.lastTee = "";
        this.data.cooldown = 0;
        this.data.granularity = 0;
        this.data.authStale = 0;
        this.data.authExpires = 0;
        this.firstTee = moment("8:00", TIME_FORMAT);
        this.lastTee = moment("17:00", TIME_FORMAT);
        this.cooldown = moment.duration(15, MINUTES);
        this.granularity = moment.duration(15, MINUTES);
        this.authStale = moment.duration(1, HOURS);
        this.authExpires = moment.duration(4, HOURS);
        this.modifiedSince = false;
    }
    get firstTee() {
        return this.cache.firstTee.clone();
    }
    set firstTee(val) {
        const ts = val.format("H:mm");
        if (ts !== this.data.firstTee) {
            this.modify();
            this.cache.firstTee = moment(ts, "H:mm");
            this.data.firstTee = ts;
        }
    }
    get lastTee() {
        return this.cache.lastTee.clone();
    }
    set lastTee(val) {
        const ts = val.format("H:mm");
        if (ts !== this.data.lastTee) {
            this.modify();
            this.cache.lastTee = moment(ts, "H:mm");
            this.data.lastTee = ts;
        }
    }
    get cooldown() {
        return this.cache.cooldown;
    }
    set cooldown(val) {
        const dn = val.asMinutes();
        if (dn !== this.data.cooldown) {
            this.modify();
            this.data.cooldown = dn;
            this.cache.cooldown = moment.duration(dn, MINUTES);
        }
    }
    get granularity() {
        return this.cache.granularity;
    }
    set granularity(val) {
        const dn = val.asMinutes();
        if (dn !== this.data.granularity) {
            this.modify();
            this.data.granularity = dn;
            this.cache.granularity = moment.duration(dn, MINUTES);
        }
    }
    get authStale() {
        return this.cache.authStale;
    }
    set authStale(val) {
        const dn = val.asMinutes();
        if (dn !== this.data.authStale) {
            this.modify();
            this.data.authStale = dn;
            this.cache.authStale = moment.duration(dn, MINUTES);
        }
    }
    get authExpires() {
        return this.cache.authExpires;
    }
    set authExpires(val) {
        const dn = val.asMinutes();
        if (dn !== this.data.authExpires) {
            this.modify();
            this.data.authExpires = dn;
            this.cache.authExpires = moment.duration(dn, MINUTES);
        }
    }
    insert() {
        return Promise.reject("Not yet implemented.");
    }
    update() {
        // TODO
        return Promise.resolve(true);
    }
}
//# sourceMappingURL=Settings.js.map